import React, { useEffect, useState } from 'react';
import APPS from '../../../components/developers/myapp/appnew';
import loginAPI from '../../../utils/ajax';
import swal from 'sweetalert';
import '../../../stylesheets/loader.scss';

const AppNew = () => {
  const [response, setResponse] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const getApps = async () => {
      const [res, error] = await loginAPI(
        'GET',
        'secure/angelbroking/client/v1/apps',
        {},
        {},
        { Authorization: 'Bearer ' + localStorage.getItem('jwtToken') }
      );

      if (res.status) {
        setResponse(res.data);
        setLoading(false);
      } else {
        swal({
          text: res?.message || 'Something went wrong',
          icon: 'warning',
          dangerMode: true,
        });
        setLoading(false);
      }
    };

    getApps();
  }, []);

  return (
    <div id='SmartAPI-loader'>
      {!loading ? (
        <APPS response={response} />
      ) : (
        <div id='load' className='loading' style={{ display: 'block' }}>
          Loading...
        </div>
      )}
    </div>
  );
};

export default AppNew;
